import * as types from '../actionTypes';
// ---- parent imports -----

export function updateBalanceSheetFor(quarterNum, updatedBalanceSheet) {
	return {
		type: types.FINANCIAL_STATEMENTS_UPDATE_BALANCE_SHEET_FOR_QUARTER,
		quarterNum,
		updatedBalanceSheet: updatedBalanceSheet
	};
}

export function updateSystemBalanceSheetFor(quarterNum, updatedBalanceSheet) {
	return {
		type: types.FINANCIAL_STATEMENTS_SYSTEM_UPDATE_BALANCE_SHEET_FOR_QUARTER,
		quarterNum,
		updatedBalanceSheet: updatedBalanceSheet
	};
}
